import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { preloadListInventoryLocations, preloadListPurchaseOrders } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

const PO_STATUSES = ['DRAFT', 'ORDERED', 'PARTIALLY_RECEIVED', 'RECEIVED', 'CANCELLED'] as const

export const Route = createFileRoute('/_authenticated/_general/inventory/receiving')({
	validateSearch: paginatedSearchWithSort(['referenceNumber', 'supplierName', 'lineCount', 'status']).extend({
		inventoryLocationUuid: z.string().optional(),
		status: z.enum(PO_STATUSES).optional()
	}),
	loaderDeps: ({ search: { limit, offset, inventoryLocationUuid, status, sortBy, sortOrder } }) => ({
		limit,
		offset,
		inventoryLocationUuid,
		status,
		sortBy,
		sortOrder
	}),
	loader: async ({ context, deps: { limit, offset, inventoryLocationUuid, status, sortBy, sortOrder } }) => {
		await Promise.all([
			preloadListPurchaseOrders(context, {
				query: { limit, offset, inventoryLocationUuid, status, sortBy, sortOrder }
			}),
			preloadListInventoryLocations(context, { query: { limit: 100, offset: 0 } })
		])
	},
	staticData: {
		crumb: ({ context: { L } }) => L.Inventory.Receiving()
	}
})
